import { Divider, Stack, Text } from '@mantine/core';
import Card from 'components/Card';
import React from 'react';
import { useReviewMasterplanStore } from 'store/reviewMasterplan';

const fallbackText = (value?: string | null) => (value && value.trim().length > 0 ? value : '-');

const CompetencyInformation = () => {
  const { formData } = useReviewMasterplanStore();

  const competencyId = fallbackText(formData?.competencyId || formData?.trReviewMasterPlanId);
  const competencyType = fallbackText(formData?.competencyType || formData?.competencytype);
  const competencyName = fallbackText(formData?.competencyName);
  const competencyDescription = fallbackText(
    formData?.competency_Description || formData?.competencyDescription
  );
  const category = fallbackText(formData?.category);
  const jobPosition = fallbackText(formData?.jobPosition || formData?.job);
  const jobbandData = formData?.jobband?.data;
  const jobBand = fallbackText(
    formData?.jobBand ||
      (Array.isArray(jobbandData) && jobbandData.length > 0 ? jobbandData.join(', ') : undefined)
  );
  const jobFamily = fallbackText(formData?.jobFamily || formData?.jobfamilyname);
  const division = fallbackText(formData?.division || formData?.businessunitname);

  return (
    <Card>
      <Stack gap={16}>
        <Stack>
          <Text c={'dark'} fw={700}>
            Competency Information
          </Text>
          <Divider />
        </Stack>
        <Stack gap={4}>
          <Text fz={'sm'} c={'dark'} fw={600}>
            Competency ID
          </Text>
          <Text fz={'sm'} c={'secondary'}>
            {competencyId}
          </Text>
        </Stack>
        <Stack gap={4}>
          <Text fz={'sm'} c={'dark'} fw={600}>
            Competency Type
          </Text>
          <Text fz={'sm'} c={'secondary'}>
            {competencyType}
          </Text>
        </Stack>
        <Stack gap={4}>
          <Text fz={'sm'} c={'dark'} fw={600}>
            Competency Name
          </Text>
          <Text fz={'sm'} c={'secondary'}>
            {competencyName}
          </Text>
        </Stack>
        <Stack gap={4}>
          <Text fz={'sm'} c={'dark'} fw={600}>
            Competency Description
          </Text>
          <Text fz={'sm'} c={'secondary'}>
            {competencyDescription}
          </Text>
        </Stack>
        <Stack gap={4}>
          <Text fz={'sm'} c={'dark'} fw={600}>
            Category
          </Text>
          <Text fz={'sm'} c={'secondary'}>
            {category}
          </Text>
        </Stack>
        <Stack gap={4}>
          <Text fz={'sm'} c={'dark'} fw={600}>
            Job Position
          </Text>
          <Text fz={'sm'} c={'secondary'}>
            {jobPosition}
          </Text>
        </Stack>
        <Stack gap={4}>
          <Text fz={'sm'} c={'dark'} fw={600}>
            Job Band
          </Text>
          <Text fz={'sm'} c={'secondary'}>
            {jobBand}
          </Text>
        </Stack>
        <Stack gap={4}>
          <Text fz={'sm'} c={'dark'} fw={600}>
            Job Family
          </Text>
          <Text fz={'sm'} c={'secondary'}>
            {jobFamily}
          </Text>
        </Stack>
        <Stack gap={4}>
          <Text fz={'sm'} c={'dark'} fw={600}>
            Division
          </Text>
          <Text fz={'sm'} c={'secondary'}>
            {division}
          </Text>
        </Stack>
      </Stack>
    </Card>
  );
};

export default CompetencyInformation;
